import { render, staticRenderFns } from "./PointsIndex.vue?vue&type=template&id=2ad8c653&scoped=true"
import script from "./PointsIndex.vue?vue&type=script&lang=js"
export * from "./PointsIndex.vue?vue&type=script&lang=js"
import style0 from "./PointsIndex.vue?vue&type=style&index=0&id=2ad8c653&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ad8c653",
  null
  
)

export default component.exports